import React, { useState, useEffect } from "react";
import Navbar from "./Navbar.js";
import { statesOfIndia } from "./FetchingPlaces/States.js";
import { citiesOfIndia } from "./FetchingPlaces/Cities.js";
import ReusableProgessBar from "components/common/ReusableProgessBar";
import DirectionLine from "./DirectionLine.js";
import { useDispatch, useSelector } from "react-redux";
import { saveContactDetails } from "../../../../../src/redux/formActions";
import { goBack } from "../../../../../src/redux/slice/onboardingFormSlice.js";
import { fetchgetInvitedUserDetailsById } from '../../../../../src/redux/slice/getInvitedUserDetailsSlice';
import { submitAllFormData } from "../../../../../src/redux/formApiActions";
import { toast, ToastContainer } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import axios from "axios";

export default function ContactDetailsForm() {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
    trigger,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange"
  });
  const InviteData = useSelector((state) => state.persistedReducer.forms.inviteData);
  const paramId = InviteData?.id;
  const { getInvitedUserDetailsById } = useSelector(state => state.getInvitedUserDetailsById);
  const { addresses } = getInvitedUserDetailsById ?? [];
  const permAddrData = addresses.find(addr => addr.addressType === "PERMANENT") || addresses[0] || {};
  const currAddrData = addresses.find(addr => addr.addressType === "CURRENT") || addresses[1] || {};
  const savedData = addresses;

  const [permanentAddress, setPermanentAddress] = useState({
    flatNo: permAddrData?.address1 || "",
    street: permAddrData?.address2 || "",
    town: permAddrData?.address3 || "",
    pincode: permAddrData?.zip || "",
    state: permAddrData?.state || "",
    city: permAddrData?.city || "",
    country: permAddrData?.country || "",
    emergencyContactNo: permAddrData?.emergencyContactNumber || "",
    emergencyRtnName: permAddrData?.emergencyContactName || "",
  });

  const [currentAddress, setCurrentAddress] = useState({
    anotherFlatNo: currAddrData?.address1 || "",
    anotherStreet: currAddrData?.address2 || "",
    anotherTown: currAddrData?.address3 || "",
    anotherPincode: currAddrData?.zip || "",
    anotherState: currAddrData?.state || "",
    anotherCity: currAddrData?.city || "",
    anotherCountry: currAddrData?.country || "",
    anotherEmergencyContactNo: currAddrData?.emergencyContactNumber || "",
    anotherEmergencyRtnName: currAddrData?.emergencyContactName || "",
  });

  const [checked, setChecked] = useState(currAddrData.sameAsPermanentAddress || false);
  const [selectedState, setSelectedState] = useState(permanentAddress.state);
  const [selectedCity, setSelectedCity] = useState(permanentAddress.city);
  const [anotherSelectedState, setAnotherSelectedState] = useState(currentAddress.anotherState);
  const [anotherSelectedCity, setAnotherSelectedCity] = useState(currentAddress.anotherCity);

  const [stateOption] = useState(statesOfIndia);
  const [cityOption, setCityOption] = useState(Object.values(citiesOfIndia).flat());
  const [anotherStateOption] = useState(statesOfIndia);
  const [anotherCityOption, setAnotherCityOption] = useState(Object.values(citiesOfIndia).flat());
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedAnotherCountry, setSelectedAnotherCountry] = useState(null);
  const INDIA_OPTION = {
    value: "India",
    label: "India"
  };

  const [pattern, setPattern] = useState({
    flatNo: "", street: "", town: "", pincode: "", emergencyContactNo: "", emergencyRtnName: "",
    anotherFlatNo: "", anotherStreet: "", anotherTown: "", anotherPincode: "", anotherEmergencyContactNo: "", anotherEmergencyRtnName: "",
  });

  const [customErrorForPattern, setCustomErrorForPattern] = useState({});

  const isSameAddress = (perm, curr) => {
    if (!perm || !curr) return false;

    const clean = (val) => val?.trim() || "";

    return (
      clean(perm.address1) === clean(curr.address1) &&
      clean(perm.address2) === clean(curr.address2) &&
      clean(perm.address3) === clean(curr.address3) &&
      clean(perm.zip) === clean(curr.zip) &&
      clean(perm.state) === clean(curr.state) &&
      clean(perm.city) === clean(curr.city) &&
      clean(perm.country) === clean(curr.country) &&
      clean(perm.emergencyContactNumber) === clean(curr.emergencyContactNumber) &&
      clean(perm.emergencyContactName) === clean(curr.emergencyContactName)
    );
  };

  useEffect(() => {
    if (addresses.length > 0) {
      const permData = addresses.find(addr => addr.addressType === "PERMANENT") || {};
      const currData = addresses.find(addr => addr.addressType === "CURRENT") || {};

      setPermanentAddress({
        flatNo: permData.address1 || "",
        street: permData.address2 || "",
        town: permData.address3 || "",
        pincode: permData.zip || "",
        state: permData.state || "",
        city: permData.city || "",
        country: permData.country || "",
        emergencyContactNo: permData.emergencyContactNumber || "",
        emergencyRtnName: permData.emergencyContactName || "",
      });

      setCurrentAddress({
        anotherFlatNo: currData.address1 || "",
        anotherStreet: currData.address2 || "",
        anotherTown: currData.address3 || "",
        anotherPincode: currData.zip || "",
        anotherState: currData.state || "",
        anotherCity: currData.city || "",
        anotherCountry: currData.country || "",
        anotherEmergencyContactNo: currData.emergencyContactNumber || "",
        anotherEmergencyRtnName: currData.emergencyContactName || "",
      });

      // Handle the "Same as Permanent" checkbox logic safely
      const apiFlag = currData.sameAsPermanentAddress;
      const isSame = isSameAddress(permData, currData);
      setChecked(apiFlag ?? isSame);
    }
  }, [getInvitedUserDetailsById, dispatch]);

  useEffect(() => {
    if (addresses.length > 0) {
      const permData = addresses.find(addr => addr.addressType === "PERMANENT");
      const currData = addresses.find(addr => addr.addressType === "CURRENT");

      if (permData?.country && countriesOptions.length) {
        const initialCountry = countriesOptions.find((opt) => opt.value === permData.country);
        if (initialCountry) {
          setSelectedCountry(initialCountry);
          setValue("country", initialCountry.value);
          handleCountrySelect(initialCountry);
        }
      }

      if (currData?.country && countriesOptions.length) {
        const initialAnotherCountry = countriesOptions.find((opt) => opt.value === currData.country);
        if (initialAnotherCountry) {
          setSelectedAnotherCountry(initialAnotherCountry);
          setValue("anotherCountry", initialAnotherCountry.value);
          handleAnotherCountrySelect(initialAnotherCountry);
        }
      }
    }
  }, [getInvitedUserDetailsById, countriesOptions]);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(
          "https://restcountries.com/v3.1/all?fields=name,demonyms",
        );
        const options = res.data
          .map((c) => ({
            value: c.name.common,
            label: c.name.common,
            demonyms: c.demonyms,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setCountriesOptions(options);

        // if (savedData?.country) {
        //   const found = options.find((o) => o.value === savedData.country);
        //   if (found) handleCountrySelect(found);
        // }
        const permData = addresses.find(
          addr => addr.addressType === "PERMANENT"
        );
        const currData = addresses.find(
          addr => addr.addressType === "CURRENT"
        );

        if (permData?.country) {
          const found = options.find(
            o => o.value === permData.country
          );
          if (found) {
            handleCountrySelect(found);
          }
        } else {
          handleCountrySelect(INDIA_OPTION);
        }
        if (currData?.country) {
          const found = options.find(
            o => o.value === currData.country
          );
          if (found) {
            handleAnotherCountrySelect(found);
          }
        } else {
          handleAnotherCountrySelect(
            INDIA_OPTION
          );
        }
      } catch (err) {
        console.error(err);
        setCountriesOptions([INDIA_OPTION]);
        setSelectedCountry(INDIA_OPTION);
        setSelectedAnotherCountry(INDIA_OPTION);
        setValue("country", "India");
        if (!checked) {
          setValue("anotherCountry", "India");
        }
      }
    };
    fetchCountries();
  }, [savedData]);

  // useEffect(() => {
  //   setCurrentAddress({
  //     anotherFlatNo: savedData?.[1]?.address1 || "",
  //     anotherStreet: savedData?.[1]?.address2 || "",
  //     anotherTown: savedData?.[1]?.address3 || "",
  //     anotherPincode: savedData?.[1]?.zip || "",
  //     anotherState: savedData?.[1]?.state || "",
  //     anotherCity: savedData?.[1]?.city || "",
  //     anotherCountry: savedData?.[1]?.country || "",
  //     anotherEmergencyContactNo: savedData?.[1]?.emergencyContactNumber || "",
  //     anotherEmergencyRtnName: savedData?.[1]?.emergencyContactName || "",
  //   });

  // }, [getInvitedUserDetailsById, dispatch])

  useEffect(() => {
    if (savedData?.length >= 2) {
      const apiFlag = savedData?.[1]?.sameAsPermanentAddress;
      const isSame = isSameAddress(savedData[0], savedData[1]);

      setChecked(apiFlag ?? isSame);
    }
  }, [savedData]);

  useEffect(() => {
    dispatch(fetchgetInvitedUserDetailsById(paramId));
  }, []);

  const handleCountrySelect = async (option) => {
    setSelectedCountry(option);
    setValue("country", option.value);
    clearErrors("country");

  };
  const handleAnotherCountrySelect = async (option) => {
    setSelectedAnotherCountry(option);
    setValue("anotherCountry", option.value);
    clearErrors("anotherCountry");

  };

  const handlePatternForAddressInputs = (e, regex, fieldName) => {
    const value = e.target.value;
    setPattern((prev) => ({ ...prev, [fieldName]: value }));

    let errorMessage = "";
    if (value && !regex.test(value)) {
      if (fieldName.toLowerCase().includes("pincode") || fieldName.toLowerCase().includes("contact")) {
        errorMessage = "Only numbers are allowed";
      } else {
        errorMessage = "No special characters are allowed";
      }
    }

    setCustomErrorForPattern((prev) => ({ ...prev, [fieldName]: errorMessage }));
    if (!errorMessage) clearErrors(fieldName);
  };

  const getLocationData = async (pincode) => {
    try {
      const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await response.json();
      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];
        const state = postOffice.State;
        const city = postOffice.Name;
        setPermanentAddress(prev => ({ ...prev, state, city }));
        setSelectedState(state);
        setSelectedCity(city);
        setCityOption(getCitiesByState(state));
        setValue("state", state);
        setValue("city", city);
        clearErrors("state");
        clearErrors("city");
      }
    } catch (error) {
      console.error("Error fetching pincode data:", error);
    }
  };

  const getAnotherLocationData = async (pincode) => {
    try {
      const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await response.json();
      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];
        const state = postOffice.State;
        const city = postOffice.Name;
        setCurrentAddress(prev => ({ ...prev, anotherState: state, anotherCity: city }));
        setAnotherSelectedState(state);
        setAnotherSelectedCity(city);
        setAnotherCityOption(getCitiesByState(state));
        setValue("anotherState", state);
        setValue("anotherCity", city);
        clearErrors("anotherState");
        clearErrors("anotherCity");
      }
    } catch (error) {
      console.error("Error fetching current address pincode data:", error);
    }
  };

  const handlePincode = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      handleAddressChange("permanent", "pincode", value);
      handlePatternForAddressInputs(e, /^\d+$/, "pincode");
      if (value.length === 6) getLocationData(value);
    }
  };

  const handleAnotherPincode = (e) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      handleAddressChange("current", "anotherPincode", value);
      handlePatternForAddressInputs(e, /^\d+$/, "anotherPincode");
      if (value.length === 6) getAnotherLocationData(value);
    }
  };

  const getCitiesByState = (state) => citiesOfIndia[state] || [];
  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setPermanentAddress(prev => ({ ...prev, state: e.target.value }));
    setCityOption(getCitiesByState(e.target.value));
  };
  const handleCityChange = (e) => setSelectedCity(e.target.value);

  const handleAnotherStateChange = (e) => {
    setAnotherSelectedState(e.target.value);
    setCurrentAddress(prev => ({ ...prev, anotherState: e.target.value }));
    setAnotherCityOption(getCitiesByState(e.target.value));
  };
  const handleAnotherCityChange = (e) => setAnotherSelectedCity(e.target.value);

  const fillSamePermanentAddress = (e) => {
    const { flatNo, street, town, pincode, state, city, country } = permanentAddress;
    const allFilled = [flatNo, street, town, pincode, state, city, country].every(
      (val) => val.trim() !== ""
    );

    if (!allFilled) {
      e.preventDefault();
      alert("Please fill all permanent address fields first.");
      return;
    }

    const newChecked = !checked;
    setChecked(newChecked);

    if (newChecked) {
      setCurrentAddress({
        anotherFlatNo: flatNo,
        anotherStreet: street,
        anotherTown: town,
        anotherPincode: pincode,
        anotherState: state,
        anotherCity: city,
        anotherCountry: country,
        anotherEmergencyContactNo: permanentAddress.emergencyContactNo,
        anotherEmergencyRtnName: permanentAddress.emergencyRtnName,
      });
      setAnotherSelectedState(state);
      setAnotherSelectedCity(city);

      Object.entries({
        anotherFlatNo: flatNo,
        anotherStreet: street,
        anotherTown: town,
        anotherPincode: pincode,
        anotherState: state,
        anotherCity: city,
        anotherCountry: country,
        anotherEmergencyContactNo: permanentAddress.emergencyContactNo,
        anotherEmergencyRtnName: permanentAddress.emergencyRtnName,
      }).forEach(([key, value]) => setValue(key, value));
    } else {
      const emptyCurrent = {
        anotherFlatNo: "",
        anotherStreet: "",
        anotherTown: "",
        anotherPincode: "",
        anotherState: "",
        anotherCity: "",
        anotherCountry: "",
        anotherEmergencyContactNo: "",
        anotherEmergencyRtnName: "",
      };
      setCurrentAddress(emptyCurrent);
      setAnotherSelectedState("");
      setAnotherSelectedCity("");
      Object.entries(emptyCurrent).forEach(([key, value]) => setValue(key, value));
    }
  };

  const handleAddressChange = (type, field, value) => {
    if (type === "permanent") setPermanentAddress(prev => ({ ...prev, [field]: value }));
    else setCurrentAddress(prev => ({ ...prev, [field]: value }));
  };

  const handleSaveDraft = async () => {
    try {
      const data = watch();
      const payload = [
        {
          address1: data.flatNo || "",
          address2: data.street || "",
          address3: data.town || "",
          addressType: "PERMANENT",
          zip: data.pincode || "",
          state: data.state || "",
          city: data.city || "",
          country: data.country || "",
          emergencyContactNumber: data.emergencyContactNo || "",
          emergencyContactName: data.emergencyRtnName || "",
        },
        {
          sameAsPermanentAddress: checked,
          address1: checked ? data.flatNo : data.anotherFlatNo || "",
          address2: checked ? data.street : data.anotherStreet || "",
          address3: checked ? data.town : data.anotherTown || "",
          addressType: "CURRENT",
          zip: checked ? data.pincode : data.anotherPincode || "",
          state: checked ? data.state : data.anotherState || "",
          city: checked ? data.city : data.anotherCity || "",
          country: checked ? data.country : data.anotherCountry || "",
          emergencyContactNumber: checked
            ? data.emergencyContactNo
            : data.anotherEmergencyContactNo || "",
          emergencyContactName: checked
            ? data.emergencyRtnName
            : data.anotherEmergencyRtnName || "",
        },
      ];

      const hasAnyValue = payload.some((addr) =>
        Object.values(addr).some((val) => val && val.toString().trim() !== "")
      );

      if (!hasAnyValue) {
        toast.warn("Please fill at least one field before saving as draft.");
        return;
      }

      const finalPayload = {
        addresses: payload,
        type: "PARTIAL_UPDATE",
        status: "DRAFT",
        suppressToast: true,
      };
      dispatch(submitAllFormData(finalPayload, paramId, "draft"));
    } catch (error) {
      toast.error("Failed to save draft. Please try again.");
      throw (error)
    }
  };

  const handleFormSubmit = (data) => {
    const payload = [
      {
        ...permAddrData, // Ensures ID and field1/field2 are preserved
        addressType: "PERMANENT",
        address1: data.flatNo || "",
        address2: data.street || "",
        address3: data.town || "",
        zip: data.pincode || "",
        state: data.state || "",
        city: data.city || "",
        country: data.country || "",
        emergencyContactNumber: data.emergencyContactNo || "",
        emergencyContactName: data.emergencyRtnName || "",
      },
      {
        ...currAddrData, // Ensures ID and field1/field2 are preserved
        addressType: "CURRENT",
        sameAsPermanentAddress: checked,
        address1: checked ? data.flatNo : data.anotherFlatNo,
        address2: checked ? data.street : data.anotherStreet,
        address3: checked ? data.town : data.anotherTown,
        zip: checked ? data.pincode : data.anotherPincode,
        state: checked ? data.state : data.anotherState,
        city: checked ? data.city : data.anotherCity,
        country: checked ? data.country : data.anotherCountry,
        emergencyContactNumber: checked ? data.emergencyContactNo : data.anotherEmergencyContactNo,
        emergencyContactName: checked ? data.emergencyRtnName : data.anotherEmergencyRtnName,
      },
    ];

    const finalPayload = {
      addresses: payload,
      type: "FULL_UPDATE",
      status: "PARTIAL_COMPLETED",
    };

    dispatch(submitAllFormData(finalPayload, paramId, "saveandnext"));
    dispatch(saveContactDetails(payload));
    sessionStorage.setItem("contactDetails", JSON.stringify(payload));
  };
  const pincodeError = errors.pincode?.message || customErrorForPattern?.pincode;
  const pincodeErrorClass = errors.pincode?.message ? "errorMessage" : "pincodeErrorMessage";
  const emergencyError = customErrorForPattern.emergencyContactNo || errors.emergencyContactNo?.message;
  const anotherPincodeError = errors.anotherPincode?.message || customErrorForPattern.anotherPincode;
  const anotherPincodeClass = errors.anotherPincode?.message ? "errorMessage" : "pincodeErrorMessage";
  const anotherEmergencyError = customErrorForPattern.anotherEmergencyContactNo || errors.anotherEmergencyContactNo?.message;
  console.log('errors', errors)
  return (
    <div className="wrapper">
      <Navbar />
      <div className="sidebar">
        <div className="sidebar-wrapper">
          <ReusableProgessBar />
        </div>
      </div>
      <div className="main-panel">
        <div className="form-content">
          <div className="container-fluid form-navbar">
            <div className="personaldetail-form">
              <DirectionLine />
              <div className="contactDetailForm">
                <div className="personalDetailHeading">
                  <h6 className="personalDetailHeadline">CONTACT DETAILS</h6>
                </div>
                <form onSubmit={handleSubmit(handleFormSubmit)} className="contactDetailContainer">
                  <div className="contact-container">
                    <div className="permanent-contact-container">
                      <div className="form-row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="flatNo" className="permanentAddressLabel">Permanent Address<span className="required">*</span></label>
                            <div className="addressline-one">
                              <input id="flatNo" type="text"
                                placeholder={errors.flatNo ? "⚠ Flat No/House No is required" : "Address: Flat No."}
                                className={`form-control flatNoInput ${errors.flatNo ? "invalid" : ""}`}
                                {...register("flatNo", { required: true, maxLength: 100, })}
                                value={permanentAddress.flatNo}
                                onChange={(e) => {
                                  handlePatternForAddressInputs(e, /^[a-zA-Z0-9\s,.'\-/#()&]+$/, "flatNo");
                                  handleAddressChange("permanent", "flatNo", e.target.value);
                                  setValue("flatNo", e.target.value, { shouldValidate: true });
                                }} onBlur={() => trigger("flatNo")}
                              />
                              {customErrorForPattern.flatNo ? (<div className="contactErrorMessage">{customErrorForPattern.flatNo}</div>) : ("")}
                              {errors.flatNo && <div className="errorMessage 2">{errors.flatNo.message}</div>}
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="addressline-two">
                              <input type="text" placeholder={errors.street ? "⚠ Tower/Street is required" : "Address: Tower/Street."}
                                className={`form-control streetInput ${errors.street ? "invalid" : ""}`}
                                {...register("street", { required: true, maxLength: 100, })}
                                value={permanentAddress.street}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handlePatternForAddressInputs(e, /^[a-zA-Z0-9\s,.'\-/#()&]+$/, "street");
                                  handleAddressChange("permanent", "street", e.target.value);
                                  setValue("street", value, { shouldValidate: true });
                                }} onBlur={() => trigger("street")}
                              />
                              {errors.street && (<div className="errorMessage">{errors.street.message}</div>)}
                              {customErrorForPattern.street && (<div className="contactErrorMessage">{customErrorForPattern.street}</div>)}
                            </div>
                          </div>

                          <div className="form-group">
                            <div className="addressline-three">
                              <input type="text" placeholder={errors.town ? "⚠ Society/Town is required" : "Address: Society/Town."}
                                className={`form-control townInput ${errors.town ? "invalid" : ""}`}
                                {...register("town", { required: true, maxLength: 50, })}
                                value={permanentAddress.town}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handlePatternForAddressInputs(e, /^[a-zA-Z0-9\s,.'\-/#()&]+$/, "town");
                                  handleAddressChange("permanent", "town", e.target.value);
                                  setValue("town", value, { shouldValidate: true });
                                }} onBlur={() => trigger("town")}
                              />
                              {customErrorForPattern.town ? (<div className="addressErrorMessage">{customErrorForPattern.town}</div>) : ("")}
                            </div>
                          </div>
                          <div className="form-group townPinCodeBox">
                            <label htmlFor="pincode">Pin Code<span className="required">*</span></label>
                            <input id="pincode" type="text"
                              maxLength={6}
                              placeholder={errors.pincode ? "⚠ Pin Code is required" : "Pin Code"}
                              className={`form-control pinCodeInput ${errors.pincode ? "invalid" : ""}`}
                              {...register("pincode", { required: true, minLength: { value: 6, message: "Pincode must be of six digits only", maxLength: { value: 6, message: "Pincode must be of six digits only", } }, })}
                              value={permanentAddress.pincode}
                              onChange={(e) => {
                                const value = e.target.value;
                                handlePincode(e);
                                handlePatternForAddressInputs(e, /^\d+$/, "pincode");
                                handleAddressChange("permanent", "pincode", e.target.value);
                                setValue("pincode", value, { shouldValidate: true });
                              }} onBlur={() => trigger("pincode")}
                            />
                            {pincodeError && (
                              <div className={pincodeErrorClass}>{pincodeError}</div>
                            )}
                          </div>

                          <div className="form-group stateCityContainer">
                            <label htmlFor="state">State<span className="required">*</span></label>
                            <select id="state" className={`form-control stateInput ${errors.state ? "invalid" : ""}`}
                              {...register("state", { required: true })}
                              value={selectedState}
                              onChange={(e) => {
                                handleStateChange(e);
                                handleAddressChange("permanent", "state", e.target.value);
                              }}
                            >
                              <option value="" hidden style={{ color: "#d3d3d3" }} >
                                {errors.state ? "⚠ State is required" : "---Select State---"}
                              </option>
                              {[...stateOption]
                                .sort((a, b) => a.localeCompare(b))
                                .map((eachState, index) => (
                                  <option key={index} value={eachState} style={{ color: "black" }}>
                                    {eachState}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group cityContainer">
                            <label htmlFor="city">City<span className="required">*</span></label>
                            <select id="city" className={`form-control cityInput ${errors.city ? "invalid" : ""}`}
                              {...register("city", { required: true })}
                              value={selectedCity}
                              onChange={(e) => {
                                handleCityChange(e);
                                handleAddressChange("permanent", "city", e.target.value);
                              }}
                            >
                              <option value="" hidden style={{ color: "#d3d3d3" }} >
                                {errors.city
                                  ? "⚠ City is required"
                                  : "---Select City---"}
                              </option>
                              {[...cityOption]
                                .sort((a, b) => a.localeCompare(b))
                                .map((eachCity, id) => (
                                  <option key={id} value={eachCity} style={{ color: "black" }} >
                                    {eachCity}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="form-group cityContainer">
                            <label htmlFor="country">Country <span className="required">*</span></label>
                            <Controller
                              name="country"
                              control={control}
                              rules={{ required: true }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={
                                    countriesOptions.length
                                      ? countriesOptions
                                      : [INDIA_OPTION]
                                  }
                                  value={

                                    (
                                      countriesOptions.length
                                        ? countriesOptions
                                        : [INDIA_OPTION]
                                    )

                                      .find(
                                        option => option.value === field.value
                                      )

                                    ||

                                    (
                                      countriesOptions.length
                                        ? countriesOptions
                                        : [INDIA_OPTION]
                                    )[0]

                                  }
                                  onChange={(option) => {
                                    field.onChange(option.value);
                                    handleCountrySelect(option);
                                    trigger("country");
                                  }}
                                  placeholder={
                                    errors.country
                                      ? "⚠ Country is required"
                                      : "---Select Country---"
                                  }
                                  isSearchable
                                  classNamePrefix="react-select"
                                  className={`form-control1 countryInput ${errors.country ? "invalid" : ""
                                    }`}
                                />
                              )}
                            />
                            {/* <input id="country" type="text"
                              placeholder={errors.country ? "⚠ Country is required" : "Country"}
                              className="form-control countryInput"
                              {...register("country", { required: true })}
                              value={permanentAddress.country}
                              onChange={(e) =>
                                handleAddressChange("permanent", "country", e.target.value)
                              }
                            /> */}
                          </div>
                          <div className="form-group emergencyContainer">
                            <label className="emergencyContactLabel" htmlFor="emergencyContactNo">Emergency Contact</label>
                            <input id="emergencyContactNo" type="telephone"
                              maxLength={10}
                              placeholder={errors.emergencyContactNo ? "⚠ Mobile No. is required" : "Mobile No."}
                              className={`form-control emergencyNoInput ${errors.emergencyContactNo ? "invalid" : ""}`}
                              {...register("emergencyContactNo", {
                                minLength: { value: 10, message: "Contact no. must be of ten digits only" },
                                maxLength: { value: 10, message: "Contact no. must be of ten digits only" },
                              })}
                              value={permanentAddress.emergencyContactNo}
                              onChange={(e) => {
                                handlePatternForAddressInputs(e, /^\d+$/, "emergencyContactNo");
                                handleAddressChange("permanent", "emergencyContactNo", e.target.value);
                              }}
                            />
                            {emergencyError && (
                              <div className="emergencyErrorMessage">{emergencyError}</div>
                            )}
                          </div>
                          <div className="form-group relationshipLabelContainer">
                            <label className="relationshipLabel" htmlFor="emergencyRtnName">Name (Relation)</label>
                            <input id="emergencyRtnName" type="text" placeholder="Name &amp; (Relation)"
                              className={`form-control emergencyNameInput ${errors.emergencyRtnName ? "invalid" : ""}`}
                              {...register("emergencyRtnName", { maxLength: 50 })}
                              value={permanentAddress.emergencyRtnName}
                              onChange={(e) => {
                                handlePatternForAddressInputs(e, /^(?=.*[A-Za-z])[A-Za-z,\-()&\s]+$/, "emergencyRtnName");
                                handleAddressChange("permanent", "emergencyRtnName", e.target.value);
                              }}
                            />
                            {customErrorForPattern.emergencyRtnName ? (
                              <div className="emergencyErrorMessage">{customErrorForPattern.emergencyRtnName}</div>
                            ) : ("")}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    {/* current address */}
                    <div className="currentaddressDetailContainer">
                      <div className="currentaddressContainer">
                        <label htmlFor="fillSamePermanentAddress">Current Address same as Permanent Address ? <span className="required">*</span></label>

                        {/* <input id="fillSamePermanentAddress" type="checkbox" className="check" checked={checked} onChange={fillSamePermanentAddress} /> */}
                        <div className="checkbox-wrapper-25">
                          <input
                            id="fillSamePermanentAddress"
                            type="checkbox"
                            checked={checked}
                            onChange={fillSamePermanentAddress}
                          />
                        </div>
                      </div>
                      <hr />

                      <div className="sameForm">
                        <div className="form-row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="addressline-one">
                                <label className="permanentAddressLabel" htmlFor="anotherFlatNo">Current Address<span className="required">*</span></label>
                                <input type="text" id="anotherFlatNo"
                                  placeholder={errors.anotherFlatNo ? "⚠ Flat No/House No is required" : "Current Address: Flat No."}
                                  className={`form-control flatNoInput ${errors.anotherFlatNo ? "invalid" : ""}`}
                                  {...register("anotherFlatNo", { required: true, maxLength: 100, })}
                                  value={currentAddress.anotherFlatNo}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    handlePatternForAddressInputs(e, /^[a-zA-Z0-9\s,.'\-/#()&]+$/, "anotherFlatNo");
                                    handleAddressChange("current", "anotherFlatNo", e.target.value);
                                    setValue("anotherFlatNo", e.target.value, { shouldValidate: true });
                                  }}
                                  disabled={checked}
                                />
                                {customErrorForPattern.anotherFlatNo ? (
                                  <div className="contactErrorMessage" style={{ marginBottom: "10px", marginTop: "-11px", }} >
                                    {customErrorForPattern.anotherFlatNo}
                                  </div>
                                ) : ("")}
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="addressline-two">
                                <input type="text" placeholder={errors.anotherStreet ? "⚠ Tower/Street is required" : "Current Address: Tower/Street."}
                                  className={`form-control streetInput ${errors.anotherStreet ? "invalid" : ""}`}
                                  {...register("anotherStreet", { required: true, maxLength: 100, })}
                                  value={currentAddress.anotherStreet}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    handlePatternForAddressInputs(e, /^[a-zA-Z0-9\s,.'\-/#()&]+$/, "anotherStreet");
                                    handleAddressChange("current", "anotherStreet", e.target.value);
                                    setValue("anotherStreet", e.target.value, { shouldValidate: true });
                                  }}
                                  disabled={checked}
                                />
                                {customErrorForPattern.anotherStreet ? (
                                  <div className="contactErrorMessage">{customErrorForPattern.anotherStreet}</div>
                                ) : ("")}
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="addressline-three">
                                <input type="text" placeholder={errors.anotherTown ? "⚠ Society/Town is required" : "Current Address: Society/Town."}
                                  className={`form-control townInput ${errors.anotherTown ? "invalid" : ""}`}
                                  {...register("anotherTown", { required: true, maxLength: 50, })}
                                  value={currentAddress.anotherTown}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    handlePatternForAddressInputs(e, /^[a-zA-Z0-9\s,.'\-/#()&]+$/, "anotherTown");
                                    handleAddressChange("current", "anotherTown", e.target.value);
                                    setValue("anotherTown", e.target.value, { shouldValidate: true });
                                  }}
                                  disabled={checked}
                                />
                                {customErrorForPattern.anotherTown ? (
                                  <div className="addressErrorMessage">{customErrorForPattern.anotherTown}</div>
                                ) : ("")}
                              </div>
                            </div>
                            <div className="form-group townPinCodeBox">
                              <label htmlFor="anotherPincode">Pin Code<span className="required">*</span></label>
                              <input type="text" id="anotherPincode"
                                maxLength={6}
                                placeholder={errors.anotherPincode ? "⚠ Pin Code is required" : "CurrentPin Code"}
                                className={`form-control pinCodeInput ${errors.anotherPincode ? "invalid" : ""}`}
                                {...register("anotherPincode", {
                                  required: true, minLength: { value: 6, message: "Pincode must be of six digits only", },
                                })}
                                value={currentAddress.anotherPincode}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  handleAnotherPincode(e);
                                  handlePatternForAddressInputs(e, /^\d+$/, "anotherPincode");
                                  handleAddressChange("current", "anotherPincode", e.target.value);
                                  setValue("anotherPincode", e.target.value, { shouldValidate: true });
                                }}
                                disabled={checked}
                              />
                              {anotherPincodeError && (
                                <div className={anotherPincodeClass}>{anotherPincodeError}</div>
                              )}
                            </div>
                            <div className="form-group stateCityContainer">
                              <label htmlFor="anotherState">State<span className="required">*</span></label>
                              <select id="anotherState" className={`form-control stateInput ${errors.anotherState ? "invalid" : ""}`}
                                {...register("anotherState", { required: true, })}
                                value={anotherSelectedState}
                                onChange={(e) => {
                                  handleAnotherStateChange(e);
                                  handleAddressChange("current", "anotherState", e.target.value);
                                }}
                                disabled={checked}
                              >
                                <option value="" hidden style={{ color: "#d3d3d3" }} >
                                  {errors.anotherState
                                    ? "⚠ State is required"
                                    : "---Select State---"}
                                </option>
                                {anotherStateOption.map(
                                  (anotherEachState, index) => (
                                    <option key={index} value={anotherEachState} style={{ color: "black" }} >
                                      {anotherEachState}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group cityContainer">
                              <label className="cityLabel" htmlFor="anotherCity">City<span className="required">*</span></label>
                              <select id="anotherCity" className={`form-control cityInput ${errors.anotherCity ? "invalid" : ""}`}
                                {...register("anotherCity", { required: true, })}
                                value={anotherSelectedCity}
                                onChange={(e) => {
                                  handleAnotherCityChange(e);
                                  handleAddressChange("current", "anotherCity", e.target.value);
                                }}
                                disabled={checked}
                              >
                                <option value="" hidden style={{ color: "#d3d3d3" }} >
                                  {errors.anotherCity
                                    ? "⚠ City is required"
                                    : "---Select City---"}
                                </option>
                                {anotherCityOption.map(
                                  (anotherEachCity, id) => (
                                    <option key={id} value={anotherEachCity} style={{ color: "black" }} >
                                      {anotherEachCity}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className="form-group cityContainer">
                              <label htmlFor="country">Country <span className="required">*</span></label>
                              <Controller
                                name="anotherCountry"
                                control={control}

                                rules={{ required: true }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    isDisabled={checked}
                                    options={
                                      countriesOptions.length
                                        ? countriesOptions
                                        : [INDIA_OPTION]
                                    }
                                    value={

                                      (
                                        countriesOptions.length
                                          ? countriesOptions
                                          : [INDIA_OPTION]
                                      )

                                        .find(
                                          option => option.value === field.value
                                        )

                                      ||

                                      (
                                        countriesOptions.length
                                          ? countriesOptions
                                          : [INDIA_OPTION]
                                      )[0]

                                    }
                                    onChange={(option) => {
                                      field.onChange(option.value);
                                      handleAnotherCountrySelect(option);
                                      trigger("anotherCountry");
                                    }}
                                    placeholder={
                                      errors.country
                                        ? "⚠ Country is required"
                                        : "---Select Country---"
                                    }
                                    isSearchable
                                    classNamePrefix="react-select"
                                    className={`form-control1 countryInput ${errors.country ? "invalid" : ""
                                      }`}
                                  />
                                )}
                              />
                              {/* <input id="country" type="text"
                                placeholder={errors.anotherCountry ? "⚠ Country is required" : "Country"}
                                className={`form-control pinCodeInput ${errors.anotherCountry ? "invalid" : ""}`}
                                {...register("anotherCountry", { required: 'Country is required', })}
                                value={currentAddress.anotherCountry}
                                onChange={(e) =>
                                  handleAddressChange("current", "anotherCountry", e.target.value)
                                }
                              /> */}
                            </div>
                            <div className="form-group emergencyContainer">
                              <label className="emergencyContactLabel" htmlFor="anotherEmergencyContactNo">Emergency Contact</label>
                              <input type="text" maxLength={10} id="anotherEmergencyContactNo" placeholder="Mobile No."
                                className={`form-control emergencyNoInput ${errors.anotherEmergencyContactNo ? "invalid" : ""}`}
                                {...register("anotherEmergencyContactNo", {
                                  minLength: { value: 10, message: "Contact no. must be of ten digits only", },
                                })}
                                value={currentAddress.anotherEmergencyContactNo}
                                onChange={(e) => {
                                  handlePatternForAddressInputs(e, /^\d+$/, "anotherEmergencyContactNo");
                                  handleAddressChange("current", "anotherEmergencyContactNo", e.target.value);
                                }}
                                disabled={checked}
                              />
                              {anotherEmergencyError && (
                                <div className="emergencyErrorMessage">{anotherEmergencyError}</div>
                              )}
                            </div>
                            <div className="form-group relationshipLabelContainer">
                              <label htmlFor="anotherEmergencyRtnName" className="relationshipLabel">Name &amp; (Relation)</label>
                              <input id="anotherEmergencyRtnName" type="text" placeholder="Name (Relation)"
                                className={`form-control emergencyNameInput ${errors.anotherEmergencyRtnName ? "invalid" : ""}`}
                                {...register("anotherEmergencyRtnName")}
                                value={currentAddress.anotherEmergencyRtnName}
                                onChange={(e) => {
                                  handlePatternForAddressInputs(e, /^[A-Za-z,()&\s]+$/, "anotherEmergencyRtnName");
                                  handleAddressChange("current", "anotherEmergencyRtnName", e.target.value);
                                }}
                                disabled={checked}
                              />
                              {customErrorForPattern.anotherEmergencyRtnName ? (
                                <div className="emergencyErrorMessage">{customErrorForPattern.anotherEmergencyRtnName}</div>
                              ) : ("")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="contactSaveButtons">
                    <button type="button" className="backBtn" onClick={() => dispatch(goBack())} >
                      Back
                    </button>
                    <button type="button" className="saveBtn" onClick={handleSaveDraft} >
                      Save As Draft
                    </button>
                    <button type="submit" className="saveNextBtn">
                      Save And Next
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
